<script setup>
// core
import {ref, computed} from "vue";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";
// components
import TimerBlock from "@/components/Recurring/TimerBlockRecurring";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";

// assets
import viberPng from "@/assets/images/activation/viber.png";

const emit = defineEmits(["nextStep"])

const {t: $t} = useI18n()
const store = useStore()
const seconds = ref(180)

const hasIntervalPooling = computed(() => !store.state.activation.isPusher);

const timerFinish = () => {
    emit("nextStep", "timeOver");
}
</script>

<template>
    <div>
        <HeaderMain textCenter>{{ $t('page.code_gen1.mainheader') }}</HeaderMain>

        <div class="block">
            <img :src="viberPng" alt="viber_logo" class="msgr-icon">

            <TimerBlock
                :seconds="seconds"
                :has-timer="hasIntervalPooling"
                @timerFinish="timerFinish"
            />

            <p>{{ $t("telephony.activation.generating") }}</p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.block {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    width: 100%;
    border-radius: 11px;
    background: var(--block-color);

    img {
        margin-bottom: 35px;
    }

    p {
        font-family: "Gilroy";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 25px;
        color: var(--text-second-color);
    }

    @media screen and (max-width: 550px) {
        gap: 15px;
        p {
            line-height: 150%;
            width: 85%;
            font-size: 12px;
        }
    }

    @media screen and (max-width: 450px) {
        .msgr_icon {
            scale: 0.7;
        }

        img {
            margin-bottom: 0;
        }
    }
}
</style>
